import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M0 9.75A9.75 9.75 0 0 1 9.75 0a9.76 9.76 0 0 1 9.75 9.75 9.75 9.75 0 0 1-9.75 9.75A9.75 9.75 0 0 1 0 9.75m1.5 0A8.25 8.25 0 0 0 9.75 18 8.26 8.26 0 0 0 18 9.75a8.25 8.25 0 1 0-16.5 0m9.375 4.875a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0m-.375-3.46a3.375 3.375 0 1 0-4.125-3.29.75.75 0 0 0 1.5 0A1.875 1.875 0 1 1 9.75 9.75a.75.75 0 0 0-.75.75v.75a.75.75 0 1 0 1.5 0v-.085",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }